var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{ref:"icon",class:_vm.iconClass,attrs:{"title":_vm.iconTitle,"aria-hidden":"true"}},[_c('b-tooltip',{attrs:{"disabled":!_vm.tooltip,"target":function () { return _vm.$refs.icon; }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }